import { combineReducers } from 'redux'
import { loadingBarReducer } from 'react-redux-loading-bar'
import { connectRouter } from 'connected-react-router'

import loaderReducer from './loader/loader.reducer'
import accountReducer from './account/account.reducer'
import notificationsReducer from './notification/notification.reducer'

const rootReducer = history => combineReducers({
  router: connectRouter(history),
  loadingBar: loadingBarReducer,
  loading: loaderReducer,
  account: accountReducer,
  notifications: notificationsReducer
})

export default rootReducer
